<template>
	<div
		v-if="hasDefaultSlot"
		:class="compiledClasses"
		data-cy="button-group"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'ButtonGroup',

	props: {
		alignment: {
			type: String,
			required: false,
			default: 'left',
			validator: value => [
				'center',
				'left',
				'right',
			].indexOf(value) !== -1,
			description: 'Sets the horizontal alignment of the ButtonGroup',
		},

		direction: {
			type: String,
			required: false,
			default: 'horizontal',
			validator: value => [
				'horizontal',
				'vertical',
			].indexOf(value) !== -1,
			description: 'Sets whether the Buttons in the ButtonGroup are arranged horizontally or vertically',
		},

		grow: {
			type: String,
			required: false,
			default: 'none',
			validator: value => [
				'all',
				'center',
				'left',
				'none',
				'right',
			].indexOf(value) !== -1,
			description: 'Sets whether the ButtonGroup grows to the full-width of its container',
		},

		segmented: {
			type: Boolean,
			required: false,
			default: true,
			description: 'Sets whether the Buttons in the ButtonGroup are attached to one another',
		},
	},

	slots: {
		default: {
			required: true,
			scoped: false,
			description: 'Supplies content to the ButtonGroup',
		},
	},

	data() {
		return {
			baseClass: 'button-group',
		};
	},

	computed: {
		alignmentClass() {
			if (this.alignment !== 'left') {
				return ` ${this.baseClass}--align-${this.alignment}`;
			}
			return '';
		},

		compiledClasses() {
			let classString = `${this.baseClass}`;
			classString += `${this.alignmentClass}`;
			classString += ` ${this.baseClass}--direction-${this.direction}`;
			classString += `${this.segmentedClass}`;
			classString += `${this.growClass}`;
			return classString;
		},

		growClass() {
			if (this.grow !== 'none') {
				return ` ${this.baseClass}--grow-${this.grow}`;
			}
			return '';
		},

		hasDefaultSlot() {
			return !!this.$slots.default || !!this.$scopedSlots.default;
		},

		segmentedClass() {
			if (this.segmented) {
				return ` ${this.baseClass}--segmented`;
			}
			return '';
		},
	},
};
</script>

<style lang="scss" src="./button-group.scss" />
